import { Component } from '@angular/core';
import { IntroOneComponent } from './intro-one.component';

@Component({
  selector: 'eid-intro-one-desktop',
  templateUrl: './intro-one.desktop.component.html',
  styleUrls: ['./intro-one.desktop.component.scss']
})
export class IntroOneDesktopComponent extends IntroOneComponent {}
